<template>
    <v-layout row justify-center>
        <v-dialog v-model="modalcomments"  scrollable max-width="320px">
            <ul class="comments" style="margin-left:20px; margin-right:5px">
               <li class="comment" v-if="session">
                <a title="View this user profile" class="photo"><img :src="userdata.photo" alt="Kasper" width="50"></a>
                <textarea v-model="comment" @keyup.enter="savecomment" class="form-control" :placeholder="language==='English'?'Write your comment':'Escribe su comentario'"></textarea>
              </li>

              <li class="comment" v-for="(comments, index) in comments" :key="comments.length">
                <a  title="View this user profile" class="photo" @click="goprofileuser(comments._id_user.username)"><img :src="comments._id_user.photo[0].link" width="50"></a>
                <div class="meta">{{comments.created_at}} <a v-if="comments.isownercomment" class="reply fas fa-trash-alt" @click="deletecomment(comments._id)"></a></div>
                <div class="body">{{comments.comments}}</div>
              </li>
              <!--li class="comment level-2">
                <a href="#" title="View this user profile" class="photo"><img src="https://placehold.it/32x32" alt="Photo"></a>
                <div class="meta">John | 2012.07.24 15:21 <a class="reply">Reply</a></div>
                <div class="body">Candy soufflé bear claw apple pie bear claw marshmallow. Jelly brownie wafer chocolate jelly.marzipan pastry sesame snaps apple pie.</div>
              </li>
              <li class="comment level-3">
                <a href="#" title="View this user profile" class="photo"><img src="https://placehold.it/32x32" alt="Photo"></a>
                <div class="meta">Jane | 2012.07.24 15:32 <a class="reply">Reply</a></div>
                <div class="body">Tart apple pie bonbon applicake sesame snaps sugar plum.</div>
              </li>
              <li class="comment level-4">
                <a href="#" title="View this user profile" class="photo"><img src="https://placehold.it/32x32" alt="Photo"></a>
                <div class="meta">Jane | 2012.07.24 15:32 <a class="reply">Reply</a></div>
                <div class="body">Tart apple pie bonbon applicake sesame snaps sugar plum.</div>
              </li-->
              <infinite-loading @infinite="infiniteHandler"/>
            </ul>
        </v-dialog>
    </v-layout>
</template>
<script>
import moment from 'moment'
import {EventBus} from '@/helpers/eventbus/event-bus'
import {PostService} from '@/services'
import initVue from '@/helpers/initVue'
import InfiniteLoading from 'vue-infinite-loading'
import env from '@/config/env.example'


import {
    mapGetters,
    mapActions
} from 'vuex'

export default {
    data(){
        return{
            language: JSON.parse(localStorage.getItem('language')) !== null ? JSON.parse(localStorage.getItem('language')).language : '',
            modalcomments: false,
            comments:[],
            session:false,
            userdata:null,
            comment: '',
            page:0,
        }
    },
    props:{
        idpost:'',
        iduser: ''
    },
    sockets:{
      'getcommentpost'(data){
        if(data){
          let isequalidpost = data._id_post === this.idpost
          if(isequalidpost){
            let id = JSON.parse(localStorage.getItem('iden'))._id
            let datenew = moment(data.date).fromNow()
              data.created_at = datenew
              if(String(data._id_user._id) === id){
                data.isownercomment= true
              }else{
                data.isownercomment= false
            }
            this.comments.unshift(data)
          }
        }
      },

      'getidcommenttodelete'(data){
        if(data){
          let isequalidpost = data._id_post === this.idpost
          if(isequalidpost){
            let deletecomment = this.comments.filter(element=>String(element._id)!==data._id_comment)
            this.comments = deletecomment
          }
        }
      }
    },
    components: {
        'infinite-loading':InfiniteLoading
    },
    mounted(){
        this.getidentity()
        if(this.idpost!==''){
          this.infiniteHandler()
        }
        if(this.language === 'English'){
            moment.locale('us')
        }else{
            moment.locale('es')
        }
        EventBus.$on('changelanguage',()=>{
            let choosedlanguage = JSON.parse(localStorage.getItem('language'))
            this.language = choosedlanguage.language
            if(this.language === 'English'){
                moment.locale('us')
            }else{
                moment.locale('es')
            }
            //console.log(this.language)
            //console.log(choosedlanguage)
        })
        EventBus.$on('openmodalcomments',(data)=>{
            this.getidentity()
            this.comments=[]
            this.idpost = data.idpost
            this.iduser = data.iduser
            this.modalcomments = true
            this.infiniteHandler()
        })
    },
    methods:{
      goprofileuser(username){
        window.location = `${env.host}${username}`
      },
      deletecomment(idcomment){
        let data = {
          _id_comment:idcomment,
          _id_post: this.idpost
        }
        this.$socket.emit('deletecomment',data)
      },
      infiniteHandler: function ($state) {
        let limit = this.comments.length / 40 + 1;
        let data = {
          page: limit,
          idpost:this.idpost
        }
        PostService.listcomment(data).then(res=>{
          this.loadMore($state, res)
        })
      },
			loadMore: function ($state, response) {
        let id = JSON.parse(localStorage.getItem('iden'))._id
          if(!response.data.commentspost.length <=0){
              if ( response.data.commentspost.length ) {
                  response.data.commentspost.forEach(element=>{
                    let datenew = moment(element.date).fromNow()
                    element.created_at = datenew
                    if(String(element._id_user._id) === id){
                      element.isownercomment= true
                    }else{
                      element.isownercomment= false
                    }
                  })
                  this.comments = this.comments.concat(response.data.commentspost)
                  //console.log(this.postdata)
                  setTimeout(() => {
                      $state.loaded()
                  }, 3000);
                  /*
                  if ( response.followers.length == this.followers.length ) {
                      $state.complete();
                  }*/
              } else {
                  $state.complete()
              }
          }else{
              $state.complete()
          }
      },
      savecomment(){
        if(this.comment !== ''){
          let data = {
            comments: this.comment,
            _id_user: JSON.parse(localStorage.getItem('iden'))._id,
            _id_post: this.idpost
          }
          this.$socket.emit('savecommentpost',data)
          let isownerpost = this.iduser===JSON.parse(localStorage.getItem('iden'))._id
          if(!isownerpost){
            let datanotifications = {
              path: 'Comment Post',
              _id_post: this.idpost,
              _id_user_sender:JSON.parse(localStorage.getItem('iden'))._id,
              _id_user_sended: this.iduser,
              photo: JSON.parse(localStorage.getItem('user')).photo,
              description: JSON.parse(localStorage.getItem('user')).username
            }
            this.$socket.emit('notificationscomment',datanotifications)
          }
          this.comment = ""
        }else{
          alertify.error(this.language==='English'?'Write your comment':'Escribe tu comentario')
        }
      },
      getidentity(){
          let identity = initVue.getIdentity().identity
          let token = initVue.getIdentity().token
          this.session = initVue.isLogged(identity, token)
          if(this.session){
            this.userdata = JSON.parse(localStorage.getItem('user'))
          }
          //console.log(this.session)
      },
    }
}
</script>
<style lang="scss" scoped>

/**
 * Customs
 */
.comments:after { border-color: #fff; }
.comments:before { background-color: #fff; }
.comments .comment {
  background: #fff;
  border-radius: 10px;
  font-size: 15px;
  padding: 10px 15px;
  width:100%;
}
.comments [class*="level-"] .photo:before { background-color: #fff; }
.comments .meta { color: #ccc; }
.comments .meta a { color: inherit; }
.comments .meta a:hover { color: #34b5d0; }
.comments .body { color: #888; }

/**
 * Comments Thread
 */
.comments {
  list-style-type: none;
  padding: 6px 0 0 46px;
  position: relative;
  margin: 0 0 0 12px;
  width:100%;
}
.comments:before,
.comments .comment,
.comments .comment:after,
.comments .comment:before,
.comments .photo img,
.comments [class*="level-"] .photo:before {
  box-shadow: 0 1px 3px rgba(0,0,0,.4);
}
.comments:after,
.comments:before {
  display: block;
  content: '';
  position: absolute;
}
.comments:before {
  border-radius: 0 0 5px 5px;
  height: 100%;
  width: 8px;
  left: 0;
  top: 0;
}
.comments:after {
  box-shadow: 0 1px 3px rgba(0,0,0,.4), 0 1px 3px rgba(0,0,0,.4) inset;
  border-width: 4px;
  border-style: solid;
  border-radius: 18px;
  height: 10px;
  width: 10px;
  left: -5px;
  top: -16px;
  z-index: -1;
}
.comments .comment {
  margin-bottom: 10px;
  position: relative;
}
.comments .comment:after,
.comments .comment:before {
  border-radius: 10px;
  background-color: #fff;
  position: absolute;
  display: block;
  content: '';
}
.comments .comment:after {
  width: 12px;
  height: 12px;
  left: -14px;
  top: 7px;
}
.comments .comment:before {
  width: 5px;
  height: 5px;
  left: -22px;
  top: 16px;
}
.comments .photo {
  position: absolute;
  left: -60px;
  top: 2px;
}
.comments .photo img {
  border: 1px solid #fff;
  border-radius: 32px;
  overflow: hidden;
}
.comments .meta { margin-bottom: 5px; }
//.comments .meta .reply { display: none; float: right; }
//.comments .comment:hover .reply { display: block; }
.comments [class*="level-"] .photo:before {
  display: block;
  content: '';
  position: absolute;
  margin-top: -2px;
  height: 4px;
  width: 20px;
  left: -10px;
  top: 50%;
  z-index: -1;
}
.comments .level-2 { margin-left: 30px; }
.comments .level-3 { margin-left: 50px; }
.comments .level-4 { margin-left: 70px; }
.comments .level-5 { margin-left: 90px; }
.comments .level-6 { margin-left: 110px; }
.comments .level-3 .photo:before { width: 40px; left: -30px;}
.comments .level-4 .photo:before { width: 60px; left: -50px;}
.comments .level-5 .photo:before { width: 80px; left: -70px;}
.comments .level-6 .photo:before { width: 100px; left: -90px;}

</style>